import getUserIdentity from "../identity/getUserIdentity";
import { configureRequest } from "@asosteam/asos-web-request";
import { getAuthorisationHeader } from "../identity";
import getRequestUrl from "./getRequestUrl";
import { name, version } from "../../../appDetails";
import {
  NOTIFICATIONS_SERVICE_ID,
  NOTIFICATIONS_PREFERENCE_ID,
  OPT_IN_CHANNELS,
  OPT_IN_SOURCE_REASON
} from "./constants";

export default async () => {
  const { customerId } = await getUserIdentity();
  const authorisation = await getAuthorisationHeader();
  const headers = {
    Authorization: authorisation,
    "Content-Type": "application/json"
  };
  const request = configureRequest({ client: { name, version } });
  const url = getRequestUrl(customerId);

  await request.patch({
    url,
    headers,
    body: {
      sourceReason: OPT_IN_SOURCE_REASON,
      services: {
        [NOTIFICATIONS_SERVICE_ID]: [
          {
            preferenceId: NOTIFICATIONS_PREFERENCE_ID,
            customerChannels: OPT_IN_CHANNELS
          }
        ]
      }
    }
  });
};
